/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.defaultLanguage = process.env.DEFAULT_LANGUAGE || 'en',
config.graphQLEndpoint = process.env.GRAPH_QL_ENDPOINT || 'https://prod-cd.upmchealthplan.com/sitecore/api/graph/edge',
config.graphQLEndpointPath = process.env.GRAPH_QL_ENDPOINT_PATH || '/sitecore/api/graph/edge',
config.jssAppName = process.env.JSS_APP_NAME || 'upmchealthplan',
config.sitecoreApiHost = process.env.SITECORE_API_HOST || 'https://prod-cd.upmchealthplan.com',
config.sitecoreApiKey = process.env.SITECORE_API_KEY || '6FD03845-4AB4-47CE-9349-2B6FE898D68A',
config.sites = process.env.SITES || '[]',
module.exports = config;